import { formatMoney, unformat } from 'accounting';

const CENTS_IN_DOLLAR = 100;

const formatCents = (cents, precision = 2) => {
  const usd = parseFloat(Math.ceil(cents).toString()) / CENTS_IN_DOLLAR;

  return formatMoney(usd, '$', precision, ',', '.');
};

// 215 to 2.15
const centsAsDecimal = (price) => (price / CENTS_IN_DOLLAR).toString();

// 10800 to 108.00
const centsAsDecimalFixed = (price) => (price / CENTS_IN_DOLLAR).toFixed(2);

// 2.10 to 210
const decimalAsCents = (price) => price * CENTS_IN_DOLLAR;

// $2.10 to 2.10
const currencyAsDecimal = (price) => unformat(price);

// $2.10 to 210
const currencyAsCents = (price) => {
  const decimal = currencyAsDecimal(price);
  return decimalAsCents(decimal);
};

export {
  formatCents,
  currencyAsCents,
  currencyAsDecimal,
  decimalAsCents,
  centsAsDecimal,
  centsAsDecimalFixed
};
